module.exports = __webpack_public_path__ + "img/pill-grid-8x3-1920w.97a6077f.jpg";